import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardContent,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  LinearProgress,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 8,
    boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
    border: "1px solid rgba(18, 24, 38, 0.06)",
    minHeight: 420,
    height: "100%",
  },
  tableWrap: {
    marginTop: theme.spacing(1),
  },
  progress: {
    height: 8,
    borderRadius: 999,
  },
  progressLabel: {
    minWidth: 64,
    textAlign: "right",
    fontWeight: 600,
  },
  loadingWrap: {
    minHeight: 320,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const RegularSeasonByCompanyTable = ({ rows, loading }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography variant="subtitle1" gutterBottom>
          事業者別達成率
        </Typography>
        {loading ? (
          <Box className={classes.loadingWrap}>
            <CircularProgress size={36} />
          </Box>
        ) : (
        <TableContainer className={classes.tableWrap}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="left" style={{ width: "30%" }}>事業者</TableCell>
                <TableCell align="left" style={{ width: "20%" }}>達成率</TableCell>
                {/* <TableCell>状況</TableCell> */}
                <TableCell align="left">進捗</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={row.companyCode}>
                  <TableCell align="left" style={{ width: "30%" }}>
                    <Box style={{ marginLeft: 0 }}>
                      <Typography variant="body2" style={{ }}>
                        {row.companyName}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {row.period}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell align="left" style={{ width: "20%" }}>
                    {row.rate.toFixed(1)}%
                  </TableCell>
                  {/* <TableCell>
                    <Chip
                      size="small"
                      label={row.status}
                      style={{
                        backgroundColor:
                          row.status === "良好"
                            ? "rgba(58, 158, 118, 0.14)"
                            : "rgba(236, 147, 57, 0.14)",
                        color: row.status === "良好" ? "#177e54" : "#b25d10",
                        fontWeight: 600,
                      }}
                    />
                  </TableCell> */}
                  <TableCell align="left">
                    <Box display="flex" alignItems="center" gridGap={12}>
                      <Box flex={1}>
                        <LinearProgress
                          variant="determinate"
                          value={row.progress}
                          className={classes.progress}
                        />
                      </Box>
                      <Typography variant="body2" className={classes.progressLabel}>
                        {row.progress.toFixed(1)}%
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        )}
      </CardContent>
    </Card>
  );
};

RegularSeasonByCompanyTable.propTypes = {
  rows: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

export default RegularSeasonByCompanyTable;
